import React from 'react'
import PropTypes from 'prop-types'

import Button from '@eig-builder/core-ui/Button'

import CustomLink from './custom-link'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

const LinkButton = props => (
  <Button
    component={CustomLink}
    dataElementLocation={DataElementLocations.BODY}
    dataElementLabel={`cst-core-link-button--button-${props.dataElementSuffix}`}
    dataElementId={`cst-core-link-button--button-${props.dataElementSuffix}`}
    {...props}
  >
    {props.children}
  </Button>
)

LinkButton.propTypes = {
  dataElementSuffix: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default LinkButton
